import React from 'react';
const SvgSwipe: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.268 10.232a2.501 2.501 0 11-3.538 3.536 2.501 2.501 0 013.538-3.536M11.086 10.086L13 12l-2.027 2.027M13 12H7"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.938 18.751A8.953 8.953 0 0112 21a9 9 0 01-9-9 9 9 0 019-9c2.278 0 4.353.853 5.938 2.249"
      />
    </svg>
  );
};
export default SvgSwipe;
